export default "__VITE_ASSET__Dq60I_bL__"